/**
 * Utilities to handle sessionStorage professionally
 */

const TOKEN_KEY = 'auth_token';

export const sessionStorageUtils = {
  /**
   * Sets token in sessionStorage
   */
  setSessionToken: (token: string): void => {
    try {
      sessionStorage.setItem(TOKEN_KEY, token);
    } catch (error) {
      console.error('Error saving token to sessionStorage:', error);
      throw new Error('Could not save authentication token');
    }
  },

  /**
   * Gets token from sessionStorage
   */
  getSessionToken: (): string | null => {
    try {
      return sessionStorage.getItem(TOKEN_KEY);
    } catch (error) {
      console.error('Error getting token from sessionStorage:', error);
      return null;
    }
  },

  /**
   * Removes token from sessionStorage
   */
  clearSessionToken: (): void => {
    try {
      sessionStorage.removeItem(TOKEN_KEY);
    } catch (error) {
      console.error('Error removing token from sessionStorage:', error);
    }
  },

  /**
   * Checks if token exists in sessionStorage
   */
  hasSessionToken: (): boolean => {
    return !!sessionStorageUtils.getSessionToken();
  }
}; 